import { useRuntimeConfig } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { useCareLogger } from '../../composables/logger/useCareLogger'

type ValidationResponse = {
  success: boolean
  data?: 'all' | number | string
}

function validateAllowedUsers(value: unknown): ValidationResponse {
  if (value === 'all') return { success: true, data: value }

  if (typeof value === 'number') return { success: true, data: value }

  if (typeof value === 'string') {
    const isValidFormat = value
      .trim()
      .split(',')
      .every((id) => !Number.isNaN(Number(id.trim())))

    if (isValidFormat) return { success: true, data: value }
  }

  return { success: false }
}

export const useAuthorizeIntercomUsers = () => {
  const { logIntercomError } = useCareLogger()
  const { FF_ENABLED_INTERCOM_BY_USERS } = useRuntimeConfig().public

  const { user } = useUserStore()

  function checkAuthorizedIntercomUsers() {
    const { success, data } = validateAllowedUsers(FF_ENABLED_INTERCOM_BY_USERS)

    if (!success) {
      logIntercomError({
        errorTitle:
          '[INTERCOM] error with feature flag FF_ENABLED_INTERCOM_BY_USERS',
        errorDetail: {
          context:
            'The value of the FF_ENABLED_INTERCOM_BY_USERS must be a list of client id(s) or set to all',
          feature_flag_value: FF_ENABLED_INTERCOM_BY_USERS,
        },
      })

      return false
    }

    if (data === 'all') return true

    if (typeof data === 'number' && data === user.value?.clientId) return true

    if (
      typeof data === 'string' &&
      data
        .split(',')
        .map((id) => id.trim())
        .includes(user.value?.clientId?.toString() ?? '')
    ) {
      return true
    }

    return false
  }

  return { checkAuthorizedIntercomUsers }
}
